import { render, staticRenderFns } from "./QuickCompanyCreate.vue?vue&type=template&id=60f32978"
import script from "./QuickCompanyCreate.vue?vue&type=script&lang=js"
export * from "./QuickCompanyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports